"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nettuno": {
    "a87f386e": [{
      "hkey": "d9eacff0",
      "slug": "cioccati-zucchetti",
      "name": "Cioccati-Zucchetti",
      "primary": true,
      "skipSearch": false
    }],
    "cadolino": [{
      "hkey": "d9eacff0",
      "slug": "cioccati-zucchetti",
      "name": "Cioccati-Zucchetti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "nettuno"
    }],
    "74083133": [{
      "hkey": "d9eacff0",
      "slug": "cioccati-zucchetti",
      "name": "Cioccati-Zucchetti",
      "primary": true,
      "skipSearch": false
    }],
    "cioccati": [{
      "hkey": "d9eacff0",
      "slug": "cioccati-zucchetti",
      "name": "Cioccati-Zucchetti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "13bbddf6": [{
      "hkey": "a99678b4",
      "slug": "cretarossa-ponserico",
      "name": "Cretarossa-Ponserico",
      "primary": true,
      "skipSearch": false
    }],
    "cretarossa": [{
      "hkey": "a99678b4",
      "slug": "cretarossa-ponserico",
      "name": "Cretarossa-Ponserico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c7ff734c": [{
      "hkey": "30bcb387",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "nettuno-centro": [{
      "hkey": "30bcb387",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "31962741": [{
      "hkey": "33dfbc98",
      "slug": "loricina-seccia-tre-cancelli",
      "name": "Loricina-Seccia-Tre Cancelli",
      "primary": true,
      "skipSearch": false
    }],
    "piscina-cardillo": [{
      "hkey": "33dfbc98",
      "slug": "loricina-seccia-tre-cancelli",
      "name": "Loricina-Seccia-Tre Cancelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "nettuno"
    }],
    "f3aecc79": [{
      "hkey": "a99678b4",
      "slug": "cretarossa-ponserico",
      "name": "Cretarossa-Ponserico",
      "primary": true,
      "skipSearch": false
    }],
    "poligono": [{
      "hkey": "a99678b4",
      "slug": "cretarossa-ponserico",
      "name": "Cretarossa-Ponserico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "nettuno"
    }],
    "d3ddadbf": [{
      "hkey": "3d5e3e18",
      "slug": "san-giacomo-santa-barbara",
      "name": "San Giacomo-Santa Barbara",
      "primary": true,
      "skipSearch": false
    }],
    "san-giacomo": [{
      "hkey": "3d5e3e18",
      "slug": "san-giacomo-santa-barbara",
      "name": "San Giacomo-Santa Barbara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f1403614": [{
      "hkey": "3d5e3e18",
      "slug": "san-giacomo-santa-barbara",
      "name": "San Giacomo-Santa Barbara",
      "primary": true,
      "skipSearch": false
    }],
    "santa-barbara": [{
      "hkey": "3d5e3e18",
      "slug": "san-giacomo-santa-barbara",
      "name": "San Giacomo-Santa Barbara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "nettuno"
    }],
    "09e25f19": [{
      "hkey": "a99678b4",
      "slug": "cretarossa-ponserico",
      "name": "Cretarossa-Ponserico",
      "primary": true,
      "skipSearch": false
    }],
    "scacciapensieri": [{
      "hkey": "a99678b4",
      "slug": "cretarossa-ponserico",
      "name": "Cretarossa-Ponserico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "nettuno"
    }],
    "feb1f303": [{
      "hkey": "33dfbc98",
      "slug": "loricina-seccia-tre-cancelli",
      "name": "Loricina-Seccia-Tre Cancelli",
      "primary": true,
      "skipSearch": false
    }],
    "tre-cancelli": [{
      "hkey": "33dfbc98",
      "slug": "loricina-seccia-tre-cancelli",
      "name": "Loricina-Seccia-Tre Cancelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b9e9a87c": [{
      "hkey": "d9eacff0",
      "slug": "cioccati-zucchetti",
      "name": "Cioccati-Zucchetti",
      "primary": true,
      "skipSearch": false
    }],
    "zucchetti": [{
      "hkey": "d9eacff0",
      "slug": "cioccati-zucchetti",
      "name": "Cioccati-Zucchetti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "nettuno"
    }]
  }
};
exports["default"] = _default;